/* general: die gemeinsamen Komponenten, die ⌘K-Suche, die Seitentitel, das
 * Formular für neue Mandanten, die Hilfe und „nicht gefunden“ (2026-09-30).
 * Dieselbe Form wie `en/general.ts`. */
export default {
  ui: {
    breadcrumb: 'Brotkrümelnavigation',
    back: 'Zurück',
    updated: 'Aktualisiert {when}',
    confirm: {
      title: 'Sind Sie sicher?',
      message: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    },
    chips: {
      remove: '„{label}“ entfernen',
    },
    filters: {
      title: 'Filter',
      close: 'Filter schließen',
    },
    bulk: {
      trademark: 'Marke ausgewählt | Marken ausgewählt',
      case: 'Verfahren ausgewählt | Verfahren ausgewählt',
      client: 'Mandant ausgewählt | Mandanten ausgewählt',
      match: 'Treffer ausgewählt | Treffer ausgewählt',
      item: 'Eintrag ausgewählt | Einträge ausgewählt',
      selected: 'ausgewählt',
      clear: 'Auswahl aufheben',
    },
    pagination: {
      showing: 'Angezeigt: {range} von {total} {unit}',
      items: 'Einträgen',
      prev: 'Vorherige Seite',
      next: 'Nächste Seite',
    },
    toast: {
      region: 'Statusmeldungen',
    },
    error: {
      offlineTitle: 'Sie scheinen offline zu sein',
      offline: 'Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      timeoutTitle: 'Zeitüberschreitung der Anfrage',
      timeout: 'Der Server hat zu lange nicht geantwortet. Versuchen Sie es gleich noch einmal.',
      authTitle: 'Ihre Sitzung ist abgelaufen',
      auth: 'Melden Sie sich erneut an, um fortzufahren – Sie kehren dann auf diese Seite zurück.',
      rateTitle: 'Zu viele Anfragen',
      rate: 'Warten Sie einige Sekunden und versuchen Sie es erneut.',
      serverTitle: 'Der Server hat Probleme',
      generic: 'Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es gleich noch einmal.',
      render: 'Beim Anzeigen dieses Bereichs ist ein unerwarteter Fehler aufgetreten.',
    },
    notFound: {
      title: {
        item: 'Nicht gefunden',
        client: 'Mandant nicht gefunden',
        trademark: 'Marke nicht gefunden',
        report: 'Bericht nicht gefunden',
        case: 'Widerspruchsverfahren nicht gefunden',
      },
      sub: 'Möglicherweise wurde es gelöscht, der Link ist veraltet oder Ihr Konto hat keinen Zugriff darauf.',
    },
  },

  search: {
    label: 'In Lexentiqa suchen',
    placeholder: 'Marken, Mandanten und Verfahren suchen…',
    hint: 'Geben Sie mindestens zwei Buchstaben ein, um Marken, Mandanten und Widerspruchsverfahren zu suchen.',
    searching: 'Suche läuft…',
    noResults:
      'Keine Ergebnisse für „{q}“. Versuchen Sie einen Markennamen, einen Mandanten oder ein Aktenzeichen.',
    failed: 'Die Suche ist gerade nicht verfügbar. Versuchen Sie es gleich noch einmal.',
    navigate: 'navigieren',
    open: 'öffnen',
    close: 'schließen',
    anywhere: 'überall',
  },

  route: {
    dashboard: 'Übersicht',
    monitoring: 'Markenüberwachung',
    matchDetail: 'Trefferprüfung',
    trademarks: 'Meine Marken',
    trademarkNew: 'Marke hinzufügen',
    trademarkDetail: 'Markenakte',
    oppositions: 'Widerspruchsverfahren',
    oppositionNew: 'Neues Widerspruchsverfahren',
    oppositionDetail: 'Widerspruchsverfahren',
    reports: 'Berichte',
    reportDetail: 'Scan-Bericht',
    clients: 'Mandanten',
    clientNew: 'Mandant hinzufügen',
    clientDetail: 'Mandant',
    people: 'Personen',
    personNew: 'Neue Person',
    person: 'Personenprofil',
    clientEdit: 'Mandant bearbeiten',
    notifications: 'Benachrichtigungen',
    help: 'Hilfecenter',
    howItWorks: 'So funktioniert die Überwachung',
    roadmap: 'Was wir bauen',
    account: 'Konto',
    settings: 'Einstellungen',
    styleguide: 'Gestaltungsleitfaden',
    signIn: 'Anmelden',
    forgotPassword: 'Passwort zurücksetzen',
    setPassword: 'Passwort festlegen',
    notFound: 'Nicht gefunden',
  },

  addClient: {
    subtitle:
      'Legen Sie einen neuen Markeninhaber im Arbeitsbereich an. Die Überwachung wird je Marke festgelegt, sobald seine Marken erfasst sind.',
    create: 'Mandant anlegen',
    creating: 'Wird angelegt…',
    workspace: 'Neuen Mandanten anlegen',
    required: 'Pflichtangaben',
    company: {
      title: 'Angaben zum Unternehmen',
      sub: 'Die juristische Person, der die Marken gehören.',
      name: 'Firmenname',
      namePlaceholder: 'z. B. Beispiel GmbH',
      nameHint: 'Der vollständige Name, wie im Handelsregister eingetragen.',
      nameRequired: 'Geben Sie den Firmennamen des Mandanten ein.',
      nameShort: 'Der Name muss mindestens {n} Zeichen lang sein.',
      tradingName: 'Handelsname',
      tradingNamePlaceholder: 'Falls abweichend vom Firmennamen',
      legalForm: 'Rechtsform',
      legalFormPlaceholder: 'Rechtsform wählen…',
      registrationNumber: 'Registernummer',
      registrationNumberPlaceholder: 'EIK / Registernummer',
      founded: 'Gründungsjahr',
      foundedPlaceholder: 'JJJJ',
      industry: 'Branche',
      industryPlaceholder: 'Branche wählen…',
      size: 'Unternehmensgröße',
      sizePlaceholder: 'Größe wählen…',
      website: 'Website',
    },
    legalForm: {
      ood: 'OOD (bulgarische GmbH)',
      eood: 'EOOD (bulgarische Ein-Personen-GmbH)',
      ad: 'AD (bulgarische AG)',
      ead: 'EAD (bulgarische Ein-Personen-AG)',
      et: 'ET (bulgarischer Einzelunternehmer)',
      gmbh: 'GmbH (Deutschland, Österreich)',
      sa: 'S.A. / SARL (Frankreich u. a.)',
      inc: 'Inc. / Corp. (USA)',
      llc: 'LLC (USA)',
      other: 'Sonstige',
    },
    industry: {
      software: 'Software und SaaS',
      finance: 'Finanzdienstleistungen',
      manufacturing: 'Industrielle Fertigung',
      cosmetics: 'Kosmetik und Körperpflege',
      pharma: 'Pharma und Medizin',
      biotech: 'Biotechnologie',
      beverages: 'Getränke',
      fashion: 'Mode und Bekleidung',
      telecom: 'Telekommunikation',
      other: 'Sonstige',
    },
    size: {
      s1: '1–10 Beschäftigte',
      s2: '11–50 Beschäftigte',
      s3: '51–200 Beschäftigte',
      s4: '201–500 Beschäftigte',
      s5: '501–1.000 Beschäftigte',
      s6: 'über 1.000 Beschäftigte',
    },
    hq: {
      title: 'Sitz',
      sub: 'Wo das Unternehmen selbst eingetragen ist. Die Register, in denen seine Marken überwacht werden, werden je Marke gewählt, nicht hier.',
      country: 'Land / Region',
      countryPlaceholder: 'Land wählen…',
    },
    contact: {
      title: 'Hauptansprechpartner',
      sub: 'Wer beim Mandanten Ihr Ansprechpartner ist. Wird beim Mandanten gespeichert.',
      name: 'Name des Hauptansprechpartners',
      namePlaceholder: 'Vor- und Nachname',
      nameRequired: 'Geben Sie den Namen des Ansprechpartners ein.',
      email: 'E-Mail',
      emailRequired: 'Geben Sie die E-Mail-Adresse des Ansprechpartners ein.',
      emailInvalid: 'Geben Sie eine gültige E-Mail-Adresse ein.',
    },
    notes: {
      title: 'Interne Notizen',
      sub: 'Hintergrund für Ihr eigenes Team. Wird dem Mandanten nie angezeigt.',
      label: 'Notizen',
      placeholder:
        'Wie das Mandat zustande kam, wer den Kontakt vermittelt hat und alles, was die nächste Person, die den Mandanten übernimmt, wissen sollte.',
    },
    rail: {
      label: 'Hinweise zur Anlage',
      checklist: 'Schritte zur Anlage',
      step: 'Schritt {n}.',
      step1: 'Angaben zum Unternehmen und zum Sitz ausfüllen.',
      step2: 'Den Ansprechpartner beim Mandanten erfassen.',
      step3:
        'Nach dem Anlegen die Marken des Mandanten hinzufügen – jede Marke hat ihren eigenen Überwachungsumfang.',
      done: 'Erledigt',
    },
    actions: 'Formularaktionen',
    notSaved: 'Nichts wird gespeichert, bevor Sie den Mandanten anlegen.',
    incomplete: 'Bitte füllen Sie die Pflichtfelder aus',
    created: 'Mandant angelegt',
    createdSub: '{name} wurde Ihrer Mandantenliste hinzugefügt.',
    failed: 'Der Mandant wurde nicht angelegt',
  },

  help: {
    title: 'Hilfecenter',
    subtitle:
      'Wie das Produkt funktioniert, wo Sie was finden, und kurze Antworten auf häufige Fragen.',
    topics: 'Hilfethemen',
    topic: {
      howItWorks: 'So funktioniert die Überwachung',
      howItWorksSub:
        'Vom Markenblatt des Registers bis zum Konflikt auf Ihrem Tisch – Schritt für Schritt',
      roadmap: 'Was wir bauen und wo wir stehen',
      roadmapSub:
        'Der vollständige Entwicklungsplan in verständlicher Sprache – fertig, in Arbeit und noch offen',
      trademarksSub:
        'Die Marken Ihrer Mandanten, die Register, in denen jede überwacht wird, und ihre Dokumente',
      monitoringSub:
        'Was die Überwachung gegen die Marken Ihrer Mandanten gefunden hat und wie jedes Paar entschieden wurde',
    },
    faq: {
      title: 'Häufige Fragen',
      sub: 'Kurze Antworten dazu, wie das Produkt heute funktioniert.',
      bulletins: {
        q: 'Wie oft werden neue Markenblätter abgerufen?',
        a: 'Die Plattform prüft alle drei Stunden, ob EUIPO und WIPO neue Markenblätter veröffentlicht haben, und liest jedes ein, sobald es abgerufen ist. Nationale Register, auch das bulgarische Patentamt, werden noch nicht gelesen. Der Abgleich der neuen Anmeldungen mit Ihren Marken ist ein eigener Schritt, ein Scan, den der Betreiber der Plattform startet; für jeden Tag mit einem Scan gibt es unter Berichte einen eigenen Bericht.',
      },
      sensitivity: {
        q: 'Können wir einstellen, wie empfindlich der Abgleich ist?',
        a: 'Nicht je Kanzlei. Der Abgleich wird vom Betreiber für die ganze Plattform eingestellt, gemessen an einem Erfassungsziel: dem Anteil der Markenpaare, gegen die beim EUIPO tatsächlich Widerspruch eingelegt wurde, die das System einer Anwältin oder einem Anwalt vorlegen muss – gemessen an den eigenen Widerspruchsdaten des EUIPO. Jeder Treffer zeigt, wie er entschieden wurde: durch eine Trefferregel oder nach Prüfung durch den KI-Prüfer, mit dessen Begründung.',
      },
      clientAccess: {
        q: 'Können Mandanten einen eigenen Lesezugang erhalten?',
        a: 'Ja. Ein Mandantenkonto kann nur lesen. Es sieht ausschließlich die offenen Widerspruchsverfahren zu seinen eigenen Marken und darin nur die Schritte, Notizen und Dokumente, die die Kanzlei für den Mandanten freigegeben hat, sowie die gesetzlichen Fristen. Die Überwachung und ihre Treffer sieht es nie. Personen hinzuzufügen und festzulegen, was jede sehen darf, ist noch nicht in der App: Wenden Sie sich an den Betreiber der Plattform.',
      },
      deadlines: {
        q: 'Woher kommen die Fristen in einem Verfahren?',
        a: 'Ein aus einem Treffer eröffnetes Verfahren beginnt mit der Widerspruchsfrist der gefundenen Anmeldung, übernommen aus der Veröffentlichung des Registers. Wo die Regel hinter diesem Datum von den Anwälten der Kanzlei noch nicht bestätigt ist – bei jedem WIPO-Datum und bei Neuveröffentlichungen internationaler Registrierungen durch das EUIPO –, ist die Frist als vorläufig markiert: Prüfen Sie sie, bevor Sie sich darauf verlassen. Jede andere Frist trägt eine Anwältin oder ein Anwalt auf der Seite des Verfahrens ein. Die zuständige Person (oder, wenn niemand zugewiesen ist, das Hauptkonto der Kanzlei) wird eine Woche vorher, am Vortag, am Tag selbst und nach Ablauf erinnert – in der App und per E-Mail, sofern die Plattform E-Mails versendet und sie in den Einstellungen nicht abgeschaltet sind.',
      },
      data: {
        q: 'Wo werden unsere Daten gespeichert?',
        a: 'Die Datenbank und alle hochgeladenen Dateien liegen auf dem eigenen Server der Plattform, in einem Rechenzentrum in Deutschland, innerhalb der EU – nicht bei einem Cloud-Speicherdienst. Die Datenbank wird jede Nacht kopiert, jede Kopie wird bis zu 30 Tage aufbewahrt, und zusätzlich wird die gesamte Festplatte des Servers gesichert. Die KI-Arbeit läuft auf unserer eigenen Grafikhardware in Bulgarien: Sie erhält die zu vergleichenden Marken und gibt ihre Antwort zurück. Wird ein knapper Fall an das kostenpflichtige KI-Modell (Claude von Anthropic) weitergegeben, erhält es die beiden verglichenen Marken – ihre Namen, Waren und Dienstleistungen sowie eine schriftliche Beschreibung eines etwaigen Logos –, aber keine Mandantennamen und keine Dateien.',
      },
      search: {
        q: 'Wie finde ich schnell eine Marke, einen Mandanten oder ein Verfahren?',
        a: 'Drücken Sie auf jeder Seite ⌘K (unter Windows Strg+K) oder klicken Sie oben in das Suchfeld, und geben Sie mindestens zwei Buchstaben einer Marke, eines Mandanten oder des Titels oder Aktenzeichens eines Verfahrens ein.',
      },
    },
  },

  notFound: {
    sub: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
    back: 'Zurück zum Arbeitsbereich',
  },
} as const
